exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".-summary-row{font-weight:700;background-color:#eee!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0ee9ce4c!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/Table/TableFooter.vue
// module id = 844
// module chunks = 2